import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { CreditStatusBanner } from 'usage-based-billing-components-lib/components';
import { useLocalStorage } from '../../local-storage/hooks/useLocalStorage';
import { getIsUngatedForUsageBasedBillingInbound2025 } from '../../selectors/gateSelectors';
import { getUsageTracker } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const CREDIT_STATUS_BANNER_DISMISSAL_KEY = 'conversations-inbox-ui:CustomerAgent:creditStatusBannerDismissed';
const getCurrentMonthYear = () => {
  const now = new Date();
  return `${now.getFullYear()}-${now.getMonth()}`;
};
export const CustomerAgentCreditStatusBanner = () => {
  const isUngatedForUsageBasedBilling = useSelector(getIsUngatedForUsageBasedBillingInbound2025);
  const tracker = getUsageTracker().tracker || null;
  const [bannerDismissedAt, setBannerDismissedAt] = useLocalStorage({
    key: CREDIT_STATUS_BANNER_DISMISSAL_KEY,
    initialValue: undefined
  });
  const showBanner = bannerDismissedAt !== getCurrentMonthYear();
  const handleClose = () => {
    setBannerDismissedAt(getCurrentMonthYear());
  };
  if (!isUngatedForUsageBasedBilling || !tracker || !showBanner) {
    return null;
  }
  return /*#__PURE__*/_jsx(CreditStatusBanner, {
    screen: "conversations-inbox",
    usageTracker: tracker,
    featureName: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.customerAgentFeatureName"
    }),
    onClose: handleClose
  });
};
CustomerAgentCreditStatusBanner.displayName = 'CustomerAgentCreditStatusBanner';